<template>
  <div class="evaluation_container">
    <div class="score_content_h">
      <div class="score_content_img">
        <img :src="evaluation.member.avatar_url">
      </div>
      <div class="score_content_title">{{ evaluation.member.nickname }} <span class="gender">{{ evaluation.member.gender | genderLabelFilter }}</span></div>
    </div>
    <div class="score_conten_detail">
      <div class="time">{{ evaluation.created }}</div>
      <div class="score_d">
        <p>{{ evaluation.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'evaluation-item',
  props: ['evaluation'],
  components: {
  },
  filters: {
    genderClassFilter(gender) {
      return gender === 1 ? 'male' : (gender === 2 ? 'female' : 'unknow')
    },
    genderLabelFilter(gender) {
      return gender === 1 ? '潮爸' : (gender === 2 ? '辣妈' : '未知')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/assets/css/mixin.scss";
  .score_content_h {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .score_content_img {
      width: rem(110);
      img {
        width: 100%;
        border-radius: 100%;
      }
    }
    .score_content_title {
      width: 100%;
      padding-left: rem(20);
      font-size: rem(26);
      .gender {
        width: rem(50);
        border-radius: rem(18);
        padding: rem(3) rem(12);
        background: #ff931b;
        font-size: rem(18);
        color: #fff;
      }
    }
  }
  .score_conten_detail {
    box-sizing: border-box;
    padding-left: rem(110);
    .time {
      font-size: rem(20);
      color: #999;
    }
    .score_d {
      padding-bottom: rem(24);
      border-bottom: 1px solid #f5f5f5;
      font-size: rem(26);
      color: #333;
    }
  }
</style>
